import { ImageListItem, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { apiUrl } from "../../config";
import LoadingCircle from "../loadingCircle/LoadingCircle";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import { IconButton } from "@mui/material";

const Dialog = styled.div`
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: auto;
  z-index: 999;
`;

const ImageLightBox = styled.img`
  margin: auto;
  max-width: 70%;
  max-height: 70%;
`;

const ImageComponent = (props) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [notAPicture, setError] = useState(false);

  const onClickOutside = (e) => {
    if (e.target.localName === "img") {
      return;
    }

    setDisplayModal(false);
  };

  const handleModalClick = (e) => {
    setDisplayModal(false);
  };

  const handleImageClick = (e) => {
    setDisplayModal(true);
  };

  useEffect(() => {
    window.addEventListener("click", onClickOutside);
    return () => window.removeEventListener("click", onClickOutside);
  }, []);

  const src = `${apiUrl}/salesforce/${props.accountId}/cases/${props.claimId}/attachments/${props.documentId}`;

  return (
    <>
      {loaded || notAPicture ? null : <LoadingCircle />}
      <div>
        <ImageListItem key={props.documentId}>
          {notAPicture ? (
            <>
              <IconButton
                sx={{ margin: "auto" }}
                aria-label={props.alt}
                onClick={() => window.open(src, "_blank")}
              >
                <SimCardDownloadIcon
                  sx={{ width: "100px", height: "100px" }}
                  fontSize="large"
                />
              </IconButton>
              <Typography sx={{ margin: "auto" }}>{props.fileName}</Typography>
            </>
          ) : (
            <img
              src={src}
              width="164"
              height="164"
              fit="crop"
              alt={props.alt}
              onClick={(e) => handleImageClick(e)}
              loading="lazy"
              onError={() => setError(true)}
              onLoad={() => setLoaded(true)}
            />
          )}
        </ImageListItem>

        {displayModal && (
          <Dialog style={{ position: "absolute" }} open>
            <ImageLightBox
              src={src}
              alt={props.documentId}
              fit="crop"
              onClick={(e) => handleModalClick(e)}
              loading="lazy"
            />
          </Dialog>
        )}
      </div>
    </>
  );
};

export default ImageComponent;
